import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import NivelAprovacao from "model/administracao/cadastro/nivelaprovacao/NivelAprovacao";
import NivelAprovacaoUsuario from "model/administracao/cadastro/nivelaprovacao/NivelAprovacaoUsuario";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import NivelAprovacaoService from "service/administracao/cadastro/nivelaprovacao/NivelAprovacaoService";

const nivelAprovacaoService = new NivelAprovacaoService();

export default function NivelAprovacaoCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [nivelAprovacao, setNivelAprovacao] = useState<NivelAprovacao>(new NivelAprovacao());
    const [titulo, setTitulo] = useState<string>('Nível de Aprovação');
    const [editando, setEditando] = useState<boolean>(false);
    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<any[]>([]);

    const inputNomeRef = useRef<any>(null);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {

        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }

        nivelAprovacaoService.usuarios().then(data => {
            setUsuariosDisponiveis(data);
        }).catch(erro => {
            msgErro("Busca de usuários", erro);
        });

    }, [])

    function validar() {

        if (!nivelAprovacao.codigo) {
            setError("codigo", { type: "manual", message: "Código é Obrigatório" }, { shouldFocus: true })
            return false;
        }

        if (!nivelAprovacao.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    const usuarioEditor = (options: any) => {
        return <Dropdown
            value={options.rowData.usuario}
            options={usuariosDisponiveis}
            filter
            optionLabel='nome'
            onChange={(e) => {
                options.rowData['usuario'] = e.target.value;
                let nivelAprovacaoLocal = { ...nivelAprovacao };
                nivelAprovacao.nivelAprovacaoUsuarios[options.rowIndex] = options.rowData;
                setNivelAprovacao(nivelAprovacaoLocal);
            }}
            style={{ width: '100%' }} placeholder="Selecione um usuário" />;
    }

    return (

        <BaseCadastro model={nivelAprovacao} service={nivelAprovacaoService} setModel={(value: NivelAprovacao) => setNivelAprovacao(value)} validar={() => validar()} urlService="/nivelaprovacao" pathCadastro="/nivelaprovacao" tituloPagina={'Nível de Aprovação'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={nivelAprovacao.ativo}
                    onChange={(e) => setNivelAprovacao({ ...nivelAprovacao, ativo: e.target.checked as boolean })}
                    style={{ marginRight: 5 }} />
                <label>Ativo</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={nivelAprovacao.codigo || undefined}
                        className={errors.codigo ? "p-invalid" : ""}
                        style={{ width: '100%' }}
                        {...register("codigo", {
                            onChange: (e) => {
                                setNivelAprovacao({ ...nivelAprovacao, codigo: e.target.value })
                                clearErrors("codigo")
                            }
                        })}
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={nivelAprovacao.nome}
                        className={errors.nome ? "p-invalid" : ""}
                        style={{ width: '100%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setNivelAprovacao({ ...nivelAprovacao, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Rotina</Label>
                <div className="col-sm-12">
                    <Dropdown
                        value={nivelAprovacao.tipoRotina}
                        className={errors.tipoRotina ? "p-invalid" : ""}
                        options={[
                            { value: "VIAGEM", label: "Viagem" },
                        ]}
                        optionLabel="label"
                        onChange={(e) => {
                            clearErrors("tipoRotina")
                            setNivelAprovacao({ ...nivelAprovacao, tipoRotina: e.value })
                        }}
                        style={{ width: '30%' }}
                    />
                </div>
                {errors.local && errors.local.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.local?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea
                        value={nivelAprovacao.observacao}
                        rows={4}
                        className={errors.observacao ? "p-invalid" : ""}
                        style={{ width: '100%' }}
                        {...register("observacao", {
                            onChange: (e) => {
                                setNivelAprovacao({ ...nivelAprovacao, observacao: e.target.value })
                                clearErrors("observacao")
                            }
                        })}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Usuários</Label>
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Usuários"
                        getNewModel={() => new NivelAprovacaoUsuario()}
                        dataKey="key"
                        lista={nivelAprovacao.nivelAprovacaoUsuarios ? nivelAprovacao.nivelAprovacaoUsuarios : []}
                        setLista={(value: any) => setNivelAprovacao({ ...nivelAprovacao, nivelAprovacaoUsuarios: value })}
                        scrollable
                        scrollHeight='500px'
                    >
                        <Column field="usuario.nome" header="Nome" editor={usuarioEditor} />
                        <Column field="usuario.email" header="Email" />
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}